import { makeAPIRequest } from "./makeRequest";

const ResetPasswordAPI = (token: string, password: string) => {
    let config
    config = {
        method: 'POST',
        url: process.env.REACT_APP_SERVER_URL + 'ResetPassword/Change',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        data: {
            "Token": token,
            "Password": password,
        }
    }

    let res = makeAPIRequest(config)
    return res
}

export default ResetPasswordAPI